import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-3xl"
}
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_4 = { class: "block text-lg font-semibold text-gray-700 dark:text-gray-300" }
const _hoisted_5 = {
  key: 0,
  class: "mb-0 mt-[3px] text-[20px]"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-0 mt-[3px] text-[20px]"
}
const _hoisted_7 = { class: "mt-[25px] md:mt-[34px] flex items-center justify-between" }
const _hoisted_8 = {
  key: 0,
  class: "inline-block text-sm text-gray-500 py-[1px] px-[8.3px] rounded-xl"
}
const _hoisted_9 = { class: "block text-sm" }
const _hoisted_10 = {
  key: 1,
  class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-3xl animate-pulse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.props.currentUserId && _ctx.props.userPermissions)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", {
              class: "w-12 h-12 rounded-xl flex items-center justify-center shadow-lg",
              style: {"background":"linear-gradient(135deg, #16a34a, #15803d)"}
            }, [
              _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "trending_up")
            ], -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.crm.revenueGrowth')), 1)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(_ctx.directT('dashboard.crm.loading')), 1))
            : (!_ctx.hasPreviousPeriodData)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_ctx.directT('dashboard.noPreviousData')), 1))
              : (_openBlock(), _createElementBlock("h5", {
                  key: 2,
                  class: _normalizeClass(["mb-0 mt-[3px] text-[20px]", {
            'text-success-600': _ctx.revenueDifference > 0,
            'text-danger-600': _ctx.revenueDifference < 0,
            'text-gray-600': _ctx.revenueDifference === 0
        }])
                }, _toDisplayString(_ctx.revenueDifference > 0 ? '+' : '') + _toDisplayString(_ctx.formatCurrency(Math.abs(_ctx.revenueDifference), _ctx.currencyCode)), 3)),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.hasPreviousPeriodData)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.directT('dashboard.noPreviousData')), 1))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["inline-block text-sm py-[1px] px-[8.3px] border rounded-xl", {
                  'text-success-700 border-success-300 bg-success-100': _ctx.percentageChange > 0,
                  'text-danger-700 border-danger-300 bg-danger-100': _ctx.percentageChange < 0,
                  'text-gray-700 border-gray-300 bg-gray-100': _ctx.percentageChange === 0
                }])
                }, _toDisplayString(_ctx.percentageChange > 0 ? '+' : '') + _toDisplayString(_ctx.percentageChange) + "% ", 3)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.directT('dashboard.last30Days')), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "h-20 bg-gray-200 dark:bg-gray-700 rounded" }, null, -1)
      ])))
}